module.exports = __webpack_public_path__ + "static/logo-d77c2a2ff818dc7f7812d15416999d82.svg";